export default "__VITE_ASSET__B8WgJ4nR__"